// React
import { useState, useEffect, useMemo } from "react";

// Redux
import { useSelector } from "react-redux";

// Context
import { useSubscriptions } from "@Common/context/subscriptions/Subscriptions";

// Hooks
import useCacheCleaner from "@/Common/hooks/CacheCleaner";

// Components
import BodyLayer from "@Layouts/components/Layers/BodyLayer";
import MyIncentivesTableList from "./MyIncentivesTableList";
import CommissionSideBar from "@Layouts/components/SideBars/CommissionSideBar";
import { getMyMotivatorsAddSubscription } from "./MyIncentivesFactory";
import { getSpiffDepartment } from "@Motivators/helpers/spiffs/position";

const QUERY_IDENTIFIERS = ["myIncentivesFirstMotivator", "myIncentivesSecondMotivator", "myIncentivesThirdMotivator"];

export default function MyIncentives() {
	const { clearCache } = useCacheCleaner();
	const { addSubscription, clearSubscriptionContext } = useSubscriptions();
	const loggedUser = useSelector((state) => state.user.user);

	const [selected, setSelected] = useState(null);

	const department = getSpiffDepartment(loggedUser?.position);

	const sideBar = useMemo(() => {
		const handlerSelection = (commissionCycle, status) => {
			if (commissionCycle?._id === selected?._id) {
				return;
			}
			setSelected(commissionCycle);

			if (status) {
				const subscriptionsQueries = getMyMotivatorsAddSubscription(commissionCycle?._id, department);
				addSubscription(["myIncentives", commissionCycle?._id], subscriptionsQueries);
			}
		};

		return <CommissionSideBar enableGenericTree selected={selected} callbackSelected={handlerSelection} />;
	}, [addSubscription, selected]);

	useEffect(() => {
		return () => {
			clearCache();
			clearSubscriptionContext();
		};
	}, [clearSubscriptionContext]);

	return (
		<BodyLayer fixedContent={sideBar}>
			<MyIncentivesTableList selected={selected} />
		</BodyLayer>
	);
}
